export const LOAD_EMAIL_HISTORY = 'LOAD_EMAIL_HISTORY'
export const LOAD_EMAIL_HISTORY_SUCCESS = 'LOAD_EMAIL_HISTORY_SUCCESS'
export const LOAD_EMAIL_HISTORY_FAILED = 'LOAD_EMAIL_HISTORY_FAILED'

export const LOAD_EMAIL_HISTORY_ITEM = 'LOAD_EMAIL_HISTORY_ITEM'
export const LOAD_EMAIL_HISTORY_ITEM_SUCCESS = 'LOAD_EMAIL_HISTORY_ITEM_SUCCESS'
export const LOAD_EMAIL_HISTORY_ITEM_FAILED = 'LOAD_EMAIL_HISTORY_ITEM_FAILED'
